export default "__VITE_ASSET__DWkiiegY__"